import { getTheme } from './getTheme';
import { useTheme as useStyledComponentsTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export function withTheme(WrappedComponent) {
  const WithDefaultTheme = props => {
    // get theme from context
    const contextTheme = useStyledComponentsTheme();

    // props first, then context, then default
    const theme = getTheme({
      theme: props.theme || contextTheme
    });
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      theme: theme
    }));
  };
  WithDefaultTheme.displayName = `WithTheme(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return WithDefaultTheme;
}
export default withTheme;